import * as React from 'react';

import { SingleProjectComponentsContent } from '../../models';
import { ComponentWrapper } from './ComponentWrapper';
import { DetailedProject } from './DetailedProject';

interface IProps {
    components: SingleProjectComponentsContent[];
}

export const ProjectComponents: React.FC<IProps> = ({ components }) => {
    const [isDetailed, toggleDetailed] = React.useState<boolean>(false);
    const [selectedSrc, setSelectedSrc] = React.useState<string | null>(null);

    const handleComponentDetailedClick = (src: string) => {
        setSelectedSrc(src);
        toggleDetailed(true);
    };

    return (
        <div>
            {
                components && components.map((component, index) => (
                    <ComponentWrapper
                        onComponentDetailedClick={handleComponentDetailedClick}
                        componentDetails={component}
                        key={index}
                        isLast={index + 1 === components.length}
                    />
                ))
            }
            <DetailedProject
                selectedSrc={selectedSrc}
                content={components}
                isOpen={isDetailed}
                onClose={() => toggleDetailed(false)}
            />
        </div>
    );
};
